import React from 'react';
import { icons } from '../utilits/icons';
import { optionElips } from '../utilits/statisticTools';
import Chart from 'react-apexcharts'

function Energy(props) {
    return (
        <div className='energy'>
            <span>{icons.energy}</span>
            <h3>Energy</h3>
            <Chart options={optionElips.options} series={optionElips.series} type="radialBar" />
        </div>
    );
}

export default Energy;